import { colors, getRgbaColor, breakpoints } from '@web-for-marketing/react-ui';

export const mediaContactStyles = {
    content: {
        '& > a': {
            textDecoration: 'none',
            color: colors.core.innovation,
            padding: '0.5rem 0.2rem',
            transition: '200ms background-color ease',
            '&:hover': {
                backgroundColor: `${getRgbaColor(colors.core.deepSpace, 0.03)} !important`,
                textDecoration: 'underline',
            },
            '&:focus': {
                outlineColor: colors.core.innovation,
                backgroundColor: `${getRgbaColor(colors.core.deepSpace, 0.06)} !important`,
                textDecoration: 'underline',
            },
            '&:active': {
                outline: 'none',
                backgroundColor: `${getRgbaColor(colors.core.deepSpace, 0.05)} !important`,
            },
        },
    },
    bodySubtitle: {
        marginBottom: '1rem',
    },
    mediaIconContainer: {
        marginBottom: '2rem',
        borderRadius: '50%',
        width: '6rem',
        height: '6rem',
        padding: '2rem',
        background: `linear-gradient(223deg, rgb(0, 128, 178) 21.7%, ${colors.core.geotab} 100%)`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    fixMargin: {
        [`@media (max-width: ${breakpoints.md})`]: {
            margin: '2.5rem 0 1rem 0',
        },
    },
};
